import React from 'react';
import { EarningsPaidContainer } from '../../../containers';

export const EarningsPaid = () => <EarningsPaidContainer />;
